import React from 'react';
import { Box } from '@mui/material';
import TermsAndConditions from './components/TermsAndConditions';
import SiteFooter from './components/SiteFooter';

const TermsPage = () => (
  <Box sx={{ minHeight: '100vh', backgroundColor: '#fafafa' }}>
    <TermsAndConditions id="terms-and-conditions" />
    <SiteFooter />
  </Box>
);

export default TermsPage;
